import {
  GET_IMEI,
  GET_IMEI_BY_ID,
  UPDATE_GLOBAL_IMEI,
  UPDATE_GLOBAL_IMEI_STATUS,
} from "../types";

const initialState = { list: [], single: [], cities: [] };

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_IMEI:
      return { ...state, list: payload };
    case GET_IMEI_BY_ID:
      return { ...state, single: payload };
    case UPDATE_GLOBAL_IMEI:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload._id ? payload : item
        ),
      };
    case UPDATE_GLOBAL_IMEI_STATUS:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload._id ? payload : item
        ),
      };
    default:
      return state;
  }
};

export default reducer;
